import { setSearchPageIndex } from 'modules/search/zustand-stores/searchStore';

import { SearchContextHeaderData } from './SearchContextHeaderData';
import { useSearchContextHeaderFetchPage } from './useSearchContextHeaderFetchPage';
import { useSearchContextHeaderInput } from './useSearchContextHeaderInput';

type Props = {
  currentObjectId: string;
};

export function useSearchContextHeader({ currentObjectId }: Props): {
  searchContext: SearchContextHeaderData | undefined;
} {
  const { searchContextInput, isSearching, searchFacets } =
    useSearchContextHeaderInput({
      currentObjectId,
    });

  useSearchContextHeaderFetchPage({ searchContextInput, isSearching });

  if (!searchContextInput) return { searchContext: undefined };

  const {
    currentResultIndex,
    pageIndex,
    resultsByPage,
    searchResultsUrl,
    searchResultsState,
    previousResult,
    previousResultPageIndex,
    nextResult,
    nextResultPageIndex,
  } = searchContextInput;

  const results = resultsByPage[pageIndex];
  const resultIndex =
    (results.hitsPerPage || 0) * results.page + currentResultIndex;

  const searchContext = {
    searchResultsUrl,
    searchResultsState,
    previousResult,
    previousResultPageIndex,
    nextResult,
    nextResultPageIndex,
    resultIndex,
    totalResults: results.nbHits,
    setPageIndex: (newPageIndex: number) => setSearchPageIndex(newPageIndex),
    searchFacets,
  } satisfies SearchContextHeaderData;

  return { searchContext };
}
